import { closeModal } from '@/helpers/closeModal';
import { getSwiperInstance } from '@/helpers/swiperInstance';
import { isCampaignLoopPlaybackEnabled } from '@/helpers/campaignSettings';
import { bindStoryDragClose } from '@/modules/actions/mobile/storyDragClose';

export const closeSwipeAction = () => {
  // モバイル表示時のみ有効
  if (!window.storeeelItems.isMobile) return;

  const swiper = getSwiperInstance();

  // SP + circle で loop_playback_enabled=false の場合、先頭グループで「前へスワイプ」したら閉じる
  if (window.storeeelItems.frame === 'circle' && !isCampaignLoopPlaybackEnabled(window.storeeelItems)) {
    if (swiper && !swiper.__storeeelEdgeSwipeCloseBound) {
      swiper.__storeeelEdgeSwipeCloseBound = true;
      let startX = 0;
      let startY = 0;

      const getPoint = (e) => {
        const touch = e?.touches?.[0] || e?.changedTouches?.[0] || e;
        return {
          x: Number.isFinite(touch?.clientX) ? touch.clientX : 0,
          y: Number.isFinite(touch?.clientY) ? touch.clientY : 0,
        };
      };

      const handleEdgeSwipeClose = (start, end) => {
        if (swiper.params?.loop) return;
        if (!swiper.isBeginning) return;

        const dx = end.x - start.x;
        const dy = end.y - start.y;
        const threshold = 60;

        // 横スワイプが優勢で、かつ「前へ」方向のスワイプ（右スワイプ）なら閉じる
        if (Math.abs(dx) > Math.abs(dy) && dx > threshold) {
          closeModal();
        }
      };

      // E2E用（mock環境で直接呼べるようにしておく）
      swiper.__storeeelEdgeSwipeCloseHandler = handleEdgeSwipeClose;

      swiper.on('touchStart', (_s, e) => {
        const p = getPoint(e);
        startX = p.x;
        startY = p.y;
      });

      // Swiper から event が渡されないケースがあるため、Swiper内部の touches も併用する
      swiper.on('touchEnd', (_s, e) => {
        const end = e ? getPoint(e) : {
          x: Number.isFinite(swiper.touches?.currentX) ? swiper.touches.currentX : (Number.isFinite(swiper.touches?.startX) ? swiper.touches.startX : startX),
          y: Number.isFinite(swiper.touches?.currentY) ? swiper.touches.currentY : (Number.isFinite(swiper.touches?.startY) ? swiper.touches.startY : startY),
        };
        handleEdgeSwipeClose({ x: startX, y: startY }, end);
      });
    }
  }

  // 下にスワイプでモーダルを閉じる
  const wrappers = document.querySelectorAll('.storeeel-swiper-group-wrapper .slide-media-wrapper');
  let threshold = 100;

  bindStoryDragClose();

  wrappers.forEach((wrapper) => {
    let startY = 0;
    let moveY = 0;
    let distance = 0;
    let startScrollTop = 0;
    let consumedPullDown = false;

    wrapper.addEventListener('touchstart', (e) => {
      startY = e.touches[0].clientY;
      // 計測開始時点のスクロール位置（ページが最上部か判定）
      const scrollingEl = document.scrollingElement || document.documentElement;
      startScrollTop = (scrollingEl && typeof scrollingEl.scrollTop === 'number') ? scrollingEl.scrollTop : (window.pageYOffset || 0);
      consumedPullDown = false;
    }, { passive: true });

    wrapper.addEventListener('touchmove', (e) => {
      moveY = e.touches[0].clientY;
      distance = moveY - startY;

      // ページ最上部での下方向スワイプ（いわゆるプル・トゥ・リフレッシュ）を抑止
      if (startScrollTop <= 0 && distance > 0) {
        e.preventDefault();
        consumedPullDown = true;
      }
    }, { passive: false });

    wrapper.addEventListener('touchend', (e) => {
      // 直前のtouchmoveでプルダウンを消費した場合は、既定動作（リロードなど）を抑止
      if (consumedPullDown && e.cancelable) {
        e.preventDefault();
      }
      // SP + circle：下スワイプで閉じる（従来動作）
      if (window.storeeelItems.frame === 'circle') {
        // ストーリー型の下スワイプ閉じは Pointer Events 側でドラッグ追従・キャンセルを扱う
        return;
      }
      // リール型は無限スクロール時に「端で閉じる」判定が不要なので、閉じ処理を行わない
      if (swiper?.params?.loop) {
        return;
      }
      // SP + square：最初と最後でスワイプ方向を判定
      const slideEls = Array.from(document.querySelectorAll('.storeeel-swiper-group-wrapper .swiper-slide'));
      const currentSlide = wrapper.closest('.storeeel-swiper-group-wrapper .swiper-slide');
      const idx = slideEls.indexOf(currentSlide);
      const lastIdx = slideEls.length - 1;
      // 最初のスライド：下スワイプで閉じる
      if (idx === 0 && distance > threshold) {
        closeModal();
      }
      // 最後のスライド：上スワイプで閉じる
      if (idx === lastIdx && distance < -threshold) {
        closeModal();
      }
    }, { passive: false });
  });
}
